import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

interface TpProps {
  fraction: number;
  hidden?: boolean;
  children: React.ReactNode;
  close: () => void;
}

export function BlockingOpenedItem(props: TpProps) {
  const docEl = document.getElementById('openedItemRoot');

  useEffect(() => {
    // document.getElementById('root')?.style.filter = "blur(8px)";
    const rootElem = document.getElementById('normalAppWrapper');
    if (rootElem) {
      if (!props.hidden) rootElem.style.filter = 'blur(3px)';
      else rootElem.style.filter = '';
    }
    // on close function
    return () => {
      if (rootElem) rootElem.style.filter = '';
    };
  });

  if (!docEl) return null;

  const wrapper = (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(255,255,255,0.25',
        position: 'absolute',
        top: 0,
        left: 0,
        display: !props.hidden ? '' : 'none',
      }}
      onMouseDown={() => {
        props.close();
      }}
    >
      <div
        style={{
          //width: 600, height:400,
          backgroundColor: 'var(--light-color)',
          boxShadow: '0 0 70px rgba(0,0,0,0.5)',
          margin: 0,
          position: 'absolute',
          top: 0,
          left: `${100 - props.fraction}%`,
          width: `${props.fraction}%`,
          height: '100%',
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
        onMouseDown={(e) => {
          e.stopPropagation();
        }}
      >
        {/* <button onClick={() => {props.close()}}>Close</button> */}
        <div style={{ width: '100%', height: '100%' }}>{props.children}</div>
      </div>
    </div>
  );
  return createPortal(wrapper, docEl);
}
